import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/material/styles";

const StyledContainer = styled('div')(({ theme }) => ({
  marginLeft: "10px",
  marginRight: "10px",
  float: "left",
  height: "64px",
  display: "flex",
  alignItems: "center",
}));

const StyledNavLink = styled(NavLink)(({ theme }) => ({
  textDecoration: "none",
  color: "inherit",
  transition: "all 0.3s ease-in-out",
  padding: "8px 16px",
  borderRadius: "8px",
  position: "relative",
  
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    transform: "translateY(-2px)",
  },
  
  "&.active": {
    color: "var(--accent-teal) !important",
    fontWeight: "600",
    
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "60%",
      height: "2px",
      background: "linear-gradient(90deg, transparent, var(--accent-teal), transparent)",
      borderRadius: "2px",
    },
  },
}));

const HeaderLinkText = ({
  text,
  to,
  onClick,
  containerClassName,
  linkClassName,
  spanClassName,
  containerProps,
  linkProps,
  textProps,
  exact = false,
  ...otherProps
}) => {
  return (
    <StyledContainer
      className={containerClassName}
      {...containerProps}
      {...otherProps}
    >
      {to ? (
        <StyledNavLink
          to={to}
          className={({ isActive }) => `${linkClassName} ${isActive ? 'active' : ''}`}
          {...linkProps}
        >
          <span className={spanClassName} {...textProps}>
            {text}
          </span>
        </StyledNavLink>
      ) : (
        <div
          onClick={onClick}
          className={linkClassName}
          role="button"
          tabIndex={0}
          onKeyPress={onClick}
          {...linkProps}
        >
          <span className={spanClassName} {...textProps}>
            {text}
          </span>
        </div>
      )}
    </StyledContainer>
  );
};

HeaderLinkText.displayName = "HeaderLinkText";

HeaderLinkText.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  containerClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  spanClassName: PropTypes.string,
  containerProps: PropTypes.object,
  linkProps: PropTypes.object,
  textProps: PropTypes.object,

  // NavLink props
  exact: PropTypes.bool,

  // The following props are only used by the "Header" component
  showWhenCollapsed: PropTypes.bool,
  showOnlyInDrawer: PropTypes.bool,
  showOnlyInHeader: PropTypes.bool,
  right: PropTypes.bool,
};

export default HeaderLinkText;